import React from 'react';
import styled from 'styled-components';
import { Link } from 'react-router-dom';
import { useLanguage } from '../i18n/LanguageContext';

const FooterContainer = styled.footer`
  padding: 2rem;
  background-color: rgba(255, 255, 255, 0.85);
  text-align: center;
  margin-top: auto;
  width: 100%;
  border-top: 1px solid var(--color-border);
  backdrop-filter: blur(10px);
`;

const FooterContent = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 1rem;
`;

const LinksContainer = styled.div`
  display: flex;
  gap: 1.5rem;
  margin-bottom: 1rem;
  flex-wrap: wrap;
  justify-content: center;
`;

const FooterLink = styled(Link)`
  color: var(--color-text-secondary);
  text-decoration: none;
  font-size: 0.9rem;
  transition: color 0.3s ease;
  
  &:hover {
    color: var(--color-accent);
    text-decoration: underline;
  }
`;

const FeedbackLink = styled.a`
  display: inline-flex;
  align-items: center;
  color: var(--color-text-secondary);
  font-size: 0.9rem;
  text-decoration: none;
  transition: color 0.3s ease;
  
  &:hover {
    color: var(--color-accent);
    text-decoration: underline;
  }
`;

const Copyright = styled.p`
  font-size: 0.875rem;
  color: var(--color-text-muted);
  margin: 0;
`;

const Footer: React.FC = () => {
  const { t } = useLanguage();
  const currentYear = new Date().getFullYear();
  
  return (
    <FooterContainer>
      <FooterContent>
        <LinksContainer>
          <FooterLink to="/solutions">
            {t('footer.useCases')}
          </FooterLink>
          <FooterLink to="/privacy-policy">
            {t('footer.privacy')}
          </FooterLink>
          <FeedbackLink href="mailto:sheetmate.ai@gmail.com">
            {t('footer.feedback')}
          </FeedbackLink>
        </LinksContainer>
        <Copyright>
          © {currentYear} SheetMate {t('footer.rights')}
        </Copyright>
      </FooterContent>
    </FooterContainer>
  );
};

export default Footer; 
